import { createContext, ReactNode } from 'react'

// Neutral extension point: lets a host app wrap the user-menu avatar trigger with its own UI
// (e.g. a popover) without the topbar knowing about the feature. Default null = avatar unchanged.
export type UserMenuSlotRenderer = (avatar: ReactNode) => ReactNode

export const UserMenuSlotContext = createContext<UserMenuSlotRenderer | null>(null)
